module.exports = __webpack_public_path__ + "img/diversity_and_inclusion.542d4285.png";